<div class="content box-shadow">
  @if (equipmentsExploitationData?.length != 0 && exploitation && exploitation.operatingHours && exploitation.operatingHours != 0) {
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-8 d-flex align-items-center mb-3" style="margin-top: 20px;">
          <label for="selectEquipments" class="mr-3 mb-0"
          style="white-space: nowrap; width: 150px;">{{ 'HIBOO.EQUIPMENTS' | translate }}</label>
          <ng-select
            id="selectEquipments"
            [items]="tabEquipments"
            [(ngModel)]="equipmentsSelectione"
            bindLabel="displayName"
            placeholder="Select Equipments"
            [multiple]="true"
            [closeOnSelect]="false"
            [clearSearchOnAdd]="true"
            class="custome-container"
            style="max-width: 500px;">
          </ng-select>
        </div>
        <div class="col-4 d-flex align-items-center justify-content-end">
          <button class="btn btn-primary d-flex align-items-center" style="height: 50%; white-space: nowrap;"
            (click)="fetchExploitationDataByEquipments()">
            <i class="fa fa-search mr-1"></i> {{ 'HIBOO.SEARCH' | translate }}
          </button>
        </div>
      </div>
      <div class="content box-shadow scrollable" style="overflow-y: auto; max-height: 500px;">
        <div class="container-fluid">
          <div class="row mb-3">
            <div class="col-6">
              <div class="box-shadow p-3 mb-3 bg-white rounded">
                <h5>{{ 'HIBOO.EFFICIENCY' | translate }}
                  @if (equipmentsExploitationData?.length > 1) {
                    <span class="small-font">
                      ({{ equipmentsExploitationData?.length }} {{ 'HIBOO.EQUIPMENTS' | translate}})
                    </span>
                  }
                </h5>
                <div class="datas-box">
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.OPERATING_RATE' | translate }}</span>
                    <span class="data-value">{{ exploitation?.operatingPercent }} %</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.USAGE_RATE' | translate }}</span>
                    <span class="data-value">{{ exploitation?.usagePercent }} %</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.IDLE_RATE' | translate }}</span>
                    <span class="data-value">{{ exploitation?.idlePercent }} %</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.FUEL_CONSUMPTION' | translate }}</span>
                    <span class="data-value">{{ exploitation?.hourlyConsumption }} L/h</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.CO2_EMISSION_RATE' | translate }}</span>
                    <span class="data-value">{{ exploitation?.co2EmissionsRate }} kg/L</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="box-shadow p-3 mb-3 bg-white rounded">
                <h5>{{'GLOBAL.EXPLOITATION' | translate }}
                  @if (equipmentsExploitationData?.length > 1) {
                    <span class="small-font">
                      ({{ equipmentsExploitationData?.length }} {{ 'HIBOO.EQUIPMENTS' | translate}})
                    </span>
                  }
                </h5>
                <div class="datas-box">
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.OPERATING_HOURS' | translate }}</span>
                    <span class="data-value">{{
                    StaticUtils.ConvertToStringHoursMinutes(exploitation?.operatingHours) }}</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.USAGE_HOURS' | translate }}</span>
                    <span class="data-value">{{
                    StaticUtils.ConvertToStringHoursMinutes(exploitation?.usageHours) }}</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.IDLE_HOURS' | translate }}</span>
                    <span class="data-value">{{ StaticUtils.ConvertToStringHoursMinutes(exploitation?.idleHours)
                    }}</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.FUEL_USED' | translate }}</span>
                    <span class="data-value">{{ exploitation?.fuelUsed | number: '1.0-0' }} L</span>
                  </div>
                  <div class="datas">
                    <span class="data-label">{{ 'HIBOO.CO2_EMISSION' | translate }}</span>
                    <span class="data-value">{{ exploitation?.co2 | number: '1.0-0' }} Kg</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (equipmentsExploitationData && equipmentsExploitationData.length > 1) {
            <div class="row mb-3">
              <div class="col-12">
                <div class="box-shadow p-3 mb-3 bg-white rounded">
                  <h5 class="p-3">{{'HIBOO.DETAILED_EXPLOITATION' | translate }}</h5>
                  <div class="row">
                    @for (exploitation of equipmentsExploitationData; track exploitation; let i = $index) {
                      <div class="col-md-6 mb-4">
                        <div class="box-shadow p-3 bg-white rounded" style="min-height: 250px;">
                          <h6>{{'GLOBAL.EXPLOITATION' | translate }} - {{ exploitation.equipementDisplayName }}</h6>
                          <div class="datas-box">
                            <div class="datas">
                              <span class="data-label">{{ 'HIBOO.OPERATING_HOURS' | translate }}</span>
                              <span class="data-value">{{
                              StaticUtils.ConvertToStringHoursMinutes(exploitation?.operatingHours) }}</span>
                            </div>
                            <div class="datas">
                              <span class="data-label">{{ 'HIBOO.USAGE_HOURS' | translate }}</span>
                              <span class="data-value">{{
                              StaticUtils.ConvertToStringHoursMinutes(exploitation?.usageHours) }}</span>
                            </div>
                            <div class="datas">
                              <span class="data-label">{{ 'HIBOO.IDLE_HOURS' | translate }}</span>
                              <span class="data-value">{{
                              StaticUtils.ConvertToStringHoursMinutes(exploitation?.idleHours) }}</span>
                            </div>
                            <div class="datas">
                              <span class="data-label">{{ 'HIBOO.FUEL_USED' | translate }}</span>
                              <span class="data-value">{{ exploitation?.fuelUsed | number: '1.0-0' }} L</span>
                            </div>
                            <div class="datas">
                              <span class="data-label">{{ 'HIBOO.CO2_EMISSION' | translate }}</span>
                              <span class="data-value">{{ exploitation?.CO2 | number: '1.0-0' }} Kg</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>